import React, { Fragment } from 'react';
import { FormGroup, ControlLabel, FormControl, Button, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'



export default function ConvergePaymentGateway(props) {

  console.log("CONVERGE PROPS", props)
  var payment_field = []

  const checkPaymentInfo = () => {
    const card = document.getElementById('card').value.replace(/\D/g, '')
    const expMonth = document.getElementById('exp_month').value.replace(/\D/g, '')
    const expYear = document.getElementById('exp_year').value.replace(/\D/g, '')
    const cvv = document.getElementById('cvv').value.replace(/\D/g, '')

    if (card.length !== 16){
      alert("The Credit Card Number must be 16 digits")
      return false
    }
    if (expMonth.length !== 2){
      alert("The Expiry Date month must be 2 digits")
      return false
    }
    if (expYear.length !== 2){
      alert("The Expiry Date year must be 2 digits")
      return false
    }
    if (!(cvv.length === 3 || cvv.length === 4)){
      alert("The CVV must be 3 or 4 digits")
      return false
    }
    return true
  }

  const grabFormData = () => {
    let validCard = checkPaymentInfo()

    console.log("ValidCard", validCard)

    if (validCard) {
      console.log("Card Validated")
    var card = document.getElementById('card').value.replace(/\D/g, '')
    var exp_year = document.getElementById('exp_year').value.replace(/\D/g, '')
    var exp_month = document.getElementById('exp_month').value.replace(/\D/g, '')
    var cvv = document.getElementById('cvv').value.replace(/\D/g, '')
    console.log("GRABBING DATA FOR PAY", exp_year)
    props.pay(card, exp_year, exp_month, cvv)
    }
  }

  if(props.paymentStatus === null || props.paymentStatus === "error" || props.paymentStatus === 'declined' ){
    props.EF1 ?
      payment_field.push(
        <div className="white-text approved-display">
          {/* <img src="smiley.png" alt="pay-success"  style={{ height: '60px', width: '60px'}} />&nbsp; */}
          <span className="mobile-title" style={{fontSize: "20px" , marginTop: "60px"}}>
            Your application has been submitted.
            </span>
          <span className="mobile-title" style={{fontSize: "14px"}}>
            We will be in touch soon!
            </span>
          {/* <span style={{fontSize: "14px", textAlign: 'center'}}>
              Someone from our team will be with you shortly.
          </span> */}
          <Button className="button2" variant="link" href={"https://www.hoopstir.com"} style={{width: 'inherit', marginTop: '1em'}}>Return to website</Button>
        </div>
      )
    :
    payment_field.push(
      <Col lg={5} md={12} sm={12} xs={12} className="payment-field">
        <div className="enrolment-payment-card">
          <div className="enrolment-section-placeholder" style={{marginBottom: 0}}>
            Enter your card details to complete registration.
          </div>
          <div className="enrolment-payment-grid">
            <FormGroup>
              <ControlLabel>Credit Card Number</ControlLabel>
              <FormControl className="opaque-grey enrolment-payment-preview-input" type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="cc-number" id="card" name="card" placeholder="" />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Expiry Month</ControlLabel>
              <FormControl className="opaque-grey enrolment-payment-preview-input" type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="cc-exp-month" name="exp_month" id="exp_month" placeholder="MM"/>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Expiry Year</ControlLabel>
              <FormControl className="opaque-grey enrolment-payment-preview-input" type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="cc-exp-year" name="exp_year" id="exp_year" placeholder="YY"/>
            </FormGroup>
          </div>
          <div className="enrolment-payment-preview-input-group">
            <FormGroup>
              <ControlLabel>CVV</ControlLabel>
              <FormControl className="opaque-grey enrolment-payment-preview-input" type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="cc-csc" name="cvv" id="cvv" placeholder="123" />
            </FormGroup>
            <div style={{ display: "flex", alignItems: "end" }}>
              {
                props.pay_spinner ? <div className="enrolment-loader"></div> :
                  <Button className="planfeaturebtn pay-button enrolment-payment-preview-button" onClick={() => grabFormData()}>Pay Now</Button>
              }
            </div>
          </div>
          <div className="card-brand-row" style={{justifyContent: "flex-start"}}>
            <img src="Visa5.png" alt="visa-option" />
            <img src="Mastercard5.png" alt="mastercard-option" />
            <img src="Discover4.png" alt="discover-option" />
            <img src="Unionpay4.png" alt="unionpay-option" />
          </div>
        </div>
      </Col>
      )
  } else if (props.paymentStatus === 'waitlist'){
    payment_field.push(
      <div className="white-text approved-display">
          <img src="smiley.png" alt="pay-success" style={{ height: '30px', width: '30px'}} />&nbsp;
          <span style={{fontSize: "14px"}}>{`You are on the waitlist: ${props.selected_program.group_name}`}</span><br/>
          <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
            <Button style={{width: "95%"}} className="button2 pay-button" onClick={props.handleRefresh}>
              Register for more events
            </Button>
          </div>
          <br/>
          <div style={{ width: "80%", display: "flex", justifyContent: "space-around"}}>
            <Button style={{width: "45%"}} className="button2 pay-button" onClick={props.handleApprovedSignOut}>
              Sign Out
            </Button>
            <Button style={{width: "45%"}} className="button2 pay-button" onClick={props.handleApprovedRedirect}>
              See Parent Portal
            </Button>
          </div>
        </div>)
  } else if (props.paymentStatus === 'approved') {
    payment_field.push(
      <div className="white-text approved-display">
        <img src="smiley.png" alt="pay-success"  style={{ height: '30px', width: '30px'}} /><br/>
        <span className="mobile-title" style={{fontSize: "1.5rem"}}>Transaction Approved. Thank you.</span><br/>
        <span style={{fontSize: "14px", textAlign: 'center'}}>
          {props.email?`A confirmation email has been sent to ${props.email}`:"A confirmation email has been sent."}
        </span>
        <span>
        {
          props.ageVerify ?
          <ControlLabel className="mobile-title control-lbl">
            <img src={"5.png"} alt="no. step" className="num-icon"/>&nbsp;
            Verify Age to complete your enrolment.
          </ControlLabel>
          : null
        }
        </span>
        <br/>
        {
          props.ageVerify ?
          //REMOVE OTHER BUTTONS AND JUST HAVE ONE BUTTON 
          <Fragment>
            <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
            <Link style={{width: "100%"}} to="/verify">
              <Button style={{width: "95%"}} className="orange-outline pay-button" >
               Verify Athletes Age
              </Button>
              </Link>
            </div>
          </Fragment>
          :
            props.league ?
            <Fragment>
              <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
                <span style={{fontSize: "14px", textAlign: "center", marginBottom: "5px" }}>
                  Log in and Generate Link from the Programs page to send to your team to register.
                </span>
                </div>
              <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
                <Button style={{width: "95%"}} className="button2 pay-button" onClick={props.handleSignIn}>
                  Log in to my new Hoopstir account
                </Button>
              </div>
              <br/>
              <div style={{ width: "80%", display: "flex", justifyContent: "space-around"}}>
                <Button style={{ width: "45%" }} className="button2 pay-button btn-width" onClick={props.handleApprovedSignOut}>
                  Log Out
                </Button>
                <Button style={{width: "45%"}} className="button2 pay-button btn-width" onClick={() => props.enrolInMoreLeagues('resetPB')}>
                  Register more Teams
                </Button>
              </div>
            </Fragment>
          :
          <Fragment>
            <div style={{ width: "80%", display: "flex", justifyContent: "center"}}>
              <Button style={{width: ""}} className="button2 pay-button" onClick={props.handleRefresh}>
                Register for more events
              </Button>
            </div>
            <br/>
            <div class="row" style={{width: "80%", display: "flex", justifyContent: "center" }}>

                <Button style={{width: "40%"}} className="button2 pay-button" onClick={props.handleApprovedSignOut}>
                  Log Out
                </Button>

                <Button style={{ width: "40%", paddingLeft: "5px" }} className="button2 pay-button" onClick={props.handleApprovedRedirect}>
                  Parent Portal
                </Button>
            </div>
          </Fragment>
        }
      </div>
    )
  }
return payment_field
}

